import FileInput, { addFiles } from './FileInput';

export default FileInput;
export { addFiles };
